import { Field, FieldProps } from 'formik';
import { ServiceType } from '@bookpeazy/common-js';

type SelectOption = {
  label: string;
  value: string | ServiceType;
}

type CustomSelectProps = {
  label?: string;
  help?: string;
  name: string
  defaultValue?: string
  options: SelectOption[]
}

const CustomSelectField: React.FC<CustomSelectProps> = ({
  label,
  name,
  help,
  defaultValue = '',
  options
}) => {
  return (
    <label>
      {label}
      <Field name={name}>
        {({ field, meta }: FieldProps<string>) => (
          <div>
            <select
              {...field}
              defaultValue={defaultValue}
              className="select w-full"
            >
              <option value="" key=""></option>
              {options.map((option, idx) => {
                return (
                  <option value={option.value} key={idx}>
                    {option.label}
                  </option>
                );
              })}
            </select>
            <span
              className={`text-sm ${meta.touched ? 'error' : ''}`}
            >
              {(meta.touched && meta.error) && meta.error}
              {!meta.touched && help}
            </span>
          </div>
        )}
      </Field>
    </label>
  );
};

export default CustomSelectField;

